export enum WorkAssignmentSourceType {
  WORK_ORDER = "WORK_ORDER",
  AMC = "AMC",
  AMC_VISIT = "AMC_VISIT",
  PETTY_WORK = "PETTY_WORK",
  SITE_VISIT = "SITE_VISIT",
  ENQUIRY = "ENQUIRY",
}

/** User-friendly labels for assignment source types (list and forms). */
export const WorkAssignmentSourceTypeLabel: Record<
  WorkAssignmentSourceType,
  string
> = {
  [WorkAssignmentSourceType.WORK_ORDER]: "Work Order",
  [WorkAssignmentSourceType.AMC]: "AMC",
  [WorkAssignmentSourceType.AMC_VISIT]: "AMC visit",
  [WorkAssignmentSourceType.PETTY_WORK]: "Petty Work",
  [WorkAssignmentSourceType.SITE_VISIT]: "Site Visit",
  [WorkAssignmentSourceType.ENQUIRY]: "Enquiry",
};

/** Workflow only — do not add values like OVERDUE; use server schedule flags on the row. */
export enum WorkAssignmentStatus {
  ASSIGNED = "ASSIGNED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

/** Allowed `status` query tokens for `GET /work-assignments`. */
export const WORK_ASSIGNMENT_LIST_STATUSES: readonly WorkAssignmentStatus[] = [
  WorkAssignmentStatus.ASSIGNED,
  WorkAssignmentStatus.COMPLETED,
  WorkAssignmentStatus.CANCELLED,
];

/** Allowed `endSource` query tokens for `GET /work-assignments`. */
export const WORK_ASSIGNMENT_LIST_END_SOURCES = ["MANUAL", "AUTO"] as const;

export type WorkAssignmentEndSource = "MANUAL" | "AUTO";

export const workAssignmentStatusMap: Record<
  WorkAssignmentStatus,
  { label: string; color: string; hint?: string }
> = {
  [WorkAssignmentStatus.ASSIGNED]: {
    label: "Assigned",
    color: "primary",
    hint: "Assignment is scheduled; work has not started yet.",
  },
  [WorkAssignmentStatus.COMPLETED]: {
    label: "Completed",
    color: "success",
    hint: "Assignment has ended.",
  },
  [WorkAssignmentStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
    hint: "Assignment was cancelled.",
  },
};
